import { ProviderContractTypesConstant } from '../constants/ProviderContractTypesConstant';
import IProviderContractType from '../interfaces/IProviderContractType';

export default function isMinor(providerContractTypeId: IProviderContractType['id']): boolean {
  return [ProviderContractTypesConstant.MPP_MINEUR, ProviderContractTypesConstant.GENERALI_VIE_MINEUR].includes(providerContractTypeId);
}
